import React, { useState, useRef, useEffect } from 'react';
import './Prediction.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';

const MultiImage = (props) => {
  const testImages = Object.keys(props.modelDetails?.annotation || {})
    .filter((key) => key.startsWith("test_"))
    .map((key) => props.modelDetails?.annotation[key]?.test_img_url);


    const similarities = Object.keys(props.modelDetails?.annotation || {})
    .filter((key) => key.startsWith("test_"))
    .map((key) => props.modelDetails?.annotation[key]?.similarity);

    const groundtruth = Object.keys(props.modelDetails?.annotation || {})
    .filter((key) => key.startsWith("test_"))
    .map((key) => props.modelDetails?.annotation[key]?.ground_truth?.[0]);

  // State for the current image index
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Ref for the scrollable container
  const imageContainerRef = useRef();

  useEffect(() => {
    

    if (props.selectedIndex !== undefined && props.selectedIndex !== currentImageIndex) {
      setCurrentImageIndex(props.selectedIndex);
  
      if (imageContainerRef.current) {
        const imageHeight = imageContainerRef.current.children[0]?.offsetHeight;
        const containerHeight = imageContainerRef.current?.offsetHeight;
  
        let scrollToPosition =
          imageHeight * props.selectedIndex - (containerHeight - imageHeight) / 2;
  
        imageContainerRef.current.scrollTo({
          top: scrollToPosition,
          behavior: "smooth",
        });
      }
    }
  }, [props.selectedIndex]);

  // Reset on reference image change
useEffect(() => {
  // Reset index
  setCurrentImageIndex(0);

  // Scroll back to the top
  if (imageContainerRef.current) {
    imageContainerRef.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}, [props.modelDetails?.reference_img_url])

  // Adjust the scroll position whenever user scrolls manually
  const handleScroll = () => {
    const container = imageContainerRef.current;
    if (container) {
      const imageHeight = container.children[0].offsetHeight;
      const containerHeight = container.offsetHeight;

      // Calculate the index of the currently centered image
      const scrollTop = container.scrollTop;
      const newIndex = Math.round((scrollTop + (containerHeight - imageHeight) / 2) / imageHeight);
      
      // Ensure the index stays within bounds
      setCurrentImageIndex(Math.max(0, Math.min(newIndex, testImages.length - 1)));
    }
  };

  // Scroll to the next or previous image and center it
  const scrollImage = (direction) => {
    let newIndex = currentImageIndex + direction;

    console.log(testImages)

    // Ensure the index stays within bounds
    if (newIndex < 0) newIndex = 0;
    if (newIndex >= testImages.length) newIndex = testImages.length - 1;

    setCurrentImageIndex(newIndex);

    if (imageContainerRef.current) {
      const imageHeight = imageContainerRef.current.children[0].offsetHeight; // Get image height
      const containerHeight = imageContainerRef.current.offsetHeight; // Get container height
      const totalHeight = imageHeight * testImages.length; // Calculate the total height of all images

      // Calculate the top position to center the image in the container
      let scrollToPosition = imageHeight * newIndex - (containerHeight - imageHeight) / 2;

      // If it's the last image, adjust the scroll position to account for the lack of margin on the last image
      if (newIndex === testImages.length - 1) {
        scrollToPosition = totalHeight - containerHeight;
      }

      imageContainerRef.current.scrollTo({
        top: scrollToPosition, // Scroll to the calculated position
        behavior: 'smooth', // Smooth scroll
      });
    }
  };

  // Add the scroll event listener when the component mounts and clean it up on unmount
  useEffect(() => {
    const container = imageContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [props.modelDetails]);

  return (
    <div className='d-a flex-column w-100 pt-5'>
      <div className="multi-image-wrapper">
        <div className="image-left">
          {props.modelDetails?.reference_img_url &&
          <img
            src={
              props.modelDetails?.reference_img_url?.startsWith("https")
              ? props.modelDetails?.reference_img_url
              : `data:image/jpeg;base64,${props.modelDetails?.reference_img_url}`}
            className="reference-image"
            onLoad={(event) =>
              props?.onReferenceImageSizeChange?.({
                width: event.currentTarget.naturalWidth,
                height: event.currentTarget.naturalHeight,
              })
            }
          />
}
        </div>
        <div className="image-right">      
        <div className="arrow-buttons">
        <button
              onClick={() => scrollImage(-1)} 
              disabled={currentImageIndex === 0}
              className="arrow-button"
            >
                 <FontAwesomeIcon icon={faAngleUp} />
            </button>  
            </div>
            
              
          <div className="test-images-container" ref={imageContainerRef}>
            {testImages.length > 0 && (
              testImages.map((testImage, index) => (
                <img
                  key={index}
                  src={
                    testImage.startsWith("https")
                    ? testImage
                    : `data:image/jpeg;base64,${testImage}`}
                  alt={`Test ${index + 1}`}
                  className={`test-image ${index === currentImageIndex ? 'active' : ''}`}
                  />
                ))
            )}
          </div>

          <div className="arrow-buttons">
          {props.modelDetails?.reference_img_url &&
          <button
                onClick={() => scrollImage(1)}
                disabled={currentImageIndex === testImages.length - 1}
                className="arrow-button"
              >
                <FontAwesomeIcon icon={faAngleDown} />
              </button>
}
              </div>
        </div>
      </div>


<div>
  <div className="similarity-score px-2 py-1 rounded mt-5 fw-bold" >
    {/* {testImages.length > 0 && (
              testImages.map((testImage, index) => (
                <>
      {index === currentImageIndex && (
        <>
                              {groundtruth[index] ? groundtruth[index] : 'N/A'}
                               </>
                               
                               )}
                          </>
              )))} */}
      {testImages.length > 0 && (
              testImages.map((testImage, index) => (
                <>
      {index === currentImageIndex && (
        <>
                               Cosine Distance : {similarities[index] ? similarities[index] : 'N/A'}
                               </>
                               
                               )}
                          </>
              )))}
              </div>
              </div>
              {props.modelDetails?.reference_img_url &&
              <p className='text-secondary mt-4'>Note: Smaller cosine distance indicates greater similarity between images</p>
}

  {!props.modelDetails?.reference_img_url && <div className=' pt-4 mb-3 mt-4' style={{paddingBottom:'18px'}}></div>}
    </div>
  );
};

export default MultiImage;
